import React from 'react';
import styled from 'styled-components';
import { media } from 'helpers/MediaHelper';
import StatusTag from 'components/ui/StatusTag';
import { featureEnabled } from 'helpers/ToggleBot';
import isEmpty from 'lodash/isEmpty';

const StyledCard = styled.div`
  background-color: white;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 24px 0;
  display: flex;
  justify-content: space-between;
`;

const StyledCardHeaderContainer = styled.div`
  padding: 0 32px;
  width: 50%;
  ${media.mobile`
    width: 100%;
  `};
`;

const StyledProjectName = styled.div`
  font-family: Circular-Black;
  font-size: 25px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const StyledProjectDescription = styled.div`
  padding: 8px 0 0;
`;

const StyledStatusTag = styled.div`
  padding: 8px 0 16px;
`;

const PageHeader = ({ name, status, description, accountName, children }) => {
  let projectDescription = description;
  if (featureEnabled('payments.merchant_subaccount') && !isEmpty(accountName)) {
    projectDescription = `${accountName} | ${description}`;
  }
  return (
    <StyledCard>
      <StyledCardHeaderContainer>
        <StyledProjectName>{name}</StyledProjectName>
        <StyledStatusTag>
          <StatusTag status={status} />
        </StyledStatusTag>
        <StyledProjectDescription>{projectDescription}</StyledProjectDescription>
      </StyledCardHeaderContainer>
      {children}
    </StyledCard>
  );
};

export default PageHeader;
